export default {"src":"/_next/static/media/videocallOutline_64.e705fc3c.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};